function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7931E",
  d: "M19.617 23.813c-2.893-.034-5.309-1.48-6.278-3.557-.987 2.11-3.454 3.557-6.398 3.557-4.1 0-6.941-2.808-6.941-6.893V5.498a3.072 3.072 0 0 1 3.062 3.064v8.375c0 2.468 1.736 4.136 4.305 4.136 2.654 0 4.39-1.668 4.423-4.136V6.894c0-.766.613-1.378 1.378-1.378h.273c.765 0 1.378.612 1.378 1.378v10.043c0 2.468 1.82 4.136 4.44 4.136 2.57 0 4.254-1.668 4.254-4.136V8.562a3.072 3.072 0 0 1 3.062-3.064v11.337c.034 3.863-3.096 7.03-6.958 6.978z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29AAE2",
  d: "M32.41 6.98v8.272a3.072 3.072 0 0 1-3.062 3.064V6.894c0-2.468-1.684-4.136-4.253-4.136-2.62 0-4.44 1.668-4.44 4.136v10.043c0 .766-.613 1.379-1.379 1.379h-.272a1.373 1.373 0 0 1-1.378-1.38V6.895c-.034-2.468-1.77-4.136-4.424-4.136-2.569 0-4.304 1.668-4.304 4.136v11.439a3.072 3.072 0 0 1-3.062-3.064V6.894C5.836 2.81 8.66.001 12.777.001c2.926 0 5.41 1.446 6.397 3.557.97-2.077 3.386-3.523 6.278-3.557 3.828-.051 6.959 3.115 6.959 6.978z"
}));

var SvgWishmakerLogoSmall = function SvgWishmakerLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWishmakerLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wishmaker-logo-small.f9ac3937.svg";
export { ForwardRef as ReactComponent };